import { downgradeComponent } from '@angular/upgrade/static';
import * as angular from 'angular';
import { GoLogoComponent } from './go-logo.component';

export const goLogoModule = angular.module('goLogoModule', [])
	.directive('goLogo', downgradeComponent({component: GoLogoComponent}))
	.name;
